import { useMemo } from 'react';
import * as Role from '../../../../../constants/role';
import * as Status from '../../../../../constants/status';
import { isDigitadorVinculado } from '../../utils/servicosPermissions';
import { rowIsMine } from '../utils/computeResumoNsir';

/**
 * ATIVO — digitador vinculado em EM_DIGITACAO
 * CONSULTA — ex-digitador com participação nesta NSIR
 * NENHUMA — demais casos
 */
export const useParticipacaoMode = ({
  nsirData,
  digitacaoContext,
  userId,
  userRole,
  nsmps,
}) => useMemo(() => {
  const isAdmin = userRole === Role.ADMIN || userRole === Role.SUPER_ADMIN;
  if (isAdmin) return 'ATIVO';

  const rawApiMode =
    digitacaoContext?.participacaoUsuario?.mode
    ?? nsirData?.participacaoUsuario?.mode;
  const apiMode =
    rawApiMode === 'CONSULTA' && userRole !== Role.DIGITADOR ? null : rawApiMode;
  if (apiMode) return apiMode;

  const vinculado = isDigitadorVinculado({
    userRole,
    digitadorId: nsirData?.digitadorId,
    userId,
  });

  if (vinculado && nsirData?.status === Status.EM_DIGITACAO) {
    return 'ATIVO';
  }

  if (userRole === Role.DIGITADOR && !vinculado) {
    const temParticipacao = (nsmps || []).some((row) => rowIsMine(row, userId));
    if (temParticipacao || nsirData?.participacaoUsuario?.meusDigitados > 0
      || digitacaoContext?.resumoNsirDigitacao?.meusDigitados > 0) {
      return 'CONSULTA';
    }
  }

  return vinculado ? 'ATIVO' : 'NENHUMA';
}, [nsirData, digitacaoContext, userId, userRole, nsmps]);

export default useParticipacaoMode;
